import { ParsedUrlQuery } from 'querystring';

import { GetStaticPaths } from 'next';

import { getOfferingsSearch } from '@arrived/api_v2';

export interface PropertyStaticPaths extends ParsedUrlQuery {
  shortName: string;
}

export const getPropertyStaticPaths: GetStaticPaths<PropertyStaticPaths> = async () => {
  // Only get the first N properties at the top. The remaining will be generated on a "as-needed" basis
  const offerings = await getOfferingsSearch({ size: 20, sort: 'propertyRank:desc,id:desc' });

  return {
    paths: offerings.data
      .filter((offering) => !offering.name.toLowerCase().includes('cypress test'))
      .map((offering) => ({ params: { shortName: offering.shortName } })),
    fallback: 'blocking',
  };
};
